import { useCallback } from 'react';

import { ParamedicalProfession } from '@dreryk/egabinet-personnel-frontend-api';

import { FormContextValues, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { personalDataTranslationKeys, personnelTranslationKeys } from '../../../../../translations';

const PARAMEDICAL_PROFESSIONS: ParamedicalProfession[] = [
   'ADDICTION_PSYCHOTHERAPY_SPECIALIST',
   'DIETITIAN',
   'PSYCHOLOGIST',
   'PSYCHOTHERAPIST',
   'OTHER',
];

type ProfessionSelectProps = Pick<FormContextValues<ProfessionValue>, 'register'>;
export type ProfessionValue = { paramedicalProfession?: ParamedicalProfession };

const useTriggerLabelExtractor = (): ((currentValue?: ParamedicalProfession) => string) => {
   const translate = useTranslate();
   return useCallback(
      (currentValue) => {
         return currentValue ? translate(personalDataTranslationKeys.profession.names[currentValue]) : '';
      },
      [translate]
   );
};

export const ProfessionSelect = (props: ProfessionSelectProps): JSX.Element => {
   return (
      <Select<ParamedicalProfession>
         triggerLabelExtractor={useTriggerLabelExtractor()}
         label={personalDataTranslationKeys.profession.label}
         placeholder={personnelTranslationKeys.choose}
         controller={props.register('paramedicalProfession', { required: true })}
         testId={'paramedicalProfession'}
      >
         <Select.List items={PARAMEDICAL_PROFESSIONS}>
            {(profession) => (
               <Select.Item
                  testId={profession}
                  item={profession}
                  label={personalDataTranslationKeys.profession.names[profession]}
               />
            )}
         </Select.List>
      </Select>
   );
};
